import withStripe from '../../../../../../hoc/withStripe';
import SavedCards from './SavedCards';

export default withStripe(SavedCards);
